// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button-module__root--xCMeY {
  /* --button-background: #fff;
  --button-border-color: #e5e5e5;
  --button-color: #1a1a1a; */

  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  border: 1px solid var(--button-border-color);
  border-radius: 6px;
  background: var(--button-background);
  color: var(--button-color);
  text-align: center;
  cursor: pointer;
}

.Button-module__shape-default--XldmJ {
  border-radius: 6px;
}

.Button-module__shape-link--GIp7Z {
  width: fit-content;
  height: auto;
  padding: 0;
  border-color: transparent;
  border-radius: 0;
  background: transparent;
}

.Button-module__variant-default--HtpMs {
  /* --button-background: #fff;
  --button-border-color: #e5e5e5;
  --button-color: #1a1a1a; */
}

.Button-module__variant-primary--avKMr {
  --button-background: #000;
  --button-border-color: #000;
  --button-color: #fff;
}

.Button-module__variant-secondary--i03KI {
  --button-background: #fff;
  --button-border-color: #000;
  --button-color: #000;
}

.Button-module__variant-accent--ECBUE {
  --button-background: #FF9800;
  --button-border-color: #FF9800;
  --button-color: #000000;
}

.Button-module__variant-ghost--Yn10J {
  --button-background: #fff;
  --button-border-color: #aaa;
  --button-color: #555;
}

.Button-module__variant-soft--UhtQK {
  --button-background: #fff4df;
  --button-border-color: #d9c6a5;
  --button-color: #333;
}

.Button-module__variant-danger--xk86T {
  --button-background: #C92A24;
  --button-border-color: #C92A24;
  --button-color: #fff;
}

.Button-module__variant-danger-weak--vygj0 {
  --button-background: #fff;
  --button-border-color: #b3261e;
  --button-color: #b3261e;
}

.Button-module__size-small--wyzgt {
  height: 32px;
  padding-inline: 20px;
  font-size: 0.75rem; /* 12px */
  font-weight: 700;
}

.Button-module__size-medium--pkW8O {
  height: 40px;
  padding-inline: 24px;
  font-size: 0.875rem; /* 14px */
  font-weight: 700;
}

.Button-module__size-large--oV3hx {
  height: 48px;
  padding-inline: 24px;
  font-size: 1rem; /* 16px */
  font-weight: 700;
}

.Button-module__shape-link--GIp7Z.Button-module__size-small--wyzgt,
.Button-module__shape-link--GIp7Z.Button-module__size-medium--pkW8O,
.Button-module__shape-link--GIp7Z.Button-module__size-large--oV3hx {
  padding-left: 10px;
  padding-right: 10px;
}

.Button-module__root--xCMeY:disabled,
.Button-module__root--xCMeY[aria-disabled='true'] {
  cursor: not-allowed;
  opacity: 0.45;
}

.Button-module__is-block--fanVi {
  width: 100%;
}

.Button-module__root--xCMeY .Button-module__leading--zEd5L {
  padding-right: 6px;
}

.Button-module__root--xCMeY .Button-module__trailing--YODmp {
  padding-left: 6px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE;;4BAE0B;;EAE1B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;;4BAE0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe,EAAE,SAAS;EAC1B,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".root {\n  /* --button-background: #fff;\n  --button-border-color: #e5e5e5;\n  --button-color: #1a1a1a; */\n\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px;\n  border: 1px solid var(--button-border-color);\n  border-radius: 6px;\n  background: var(--button-background);\n  color: var(--button-color);\n  text-align: center;\n  cursor: pointer;\n}\n\n.shape-default {\n  border-radius: 6px;\n}\n\n.shape-link {\n  width: fit-content;\n  height: auto;\n  padding: 0;\n  border-color: transparent;\n  border-radius: 0;\n  background: transparent;\n}\n\n.variant-default {\n  /* --button-background: #fff;\n  --button-border-color: #e5e5e5;\n  --button-color: #1a1a1a; */\n}\n\n.variant-primary {\n  --button-background: #000;\n  --button-border-color: #000;\n  --button-color: #fff;\n}\n\n.variant-secondary {\n  --button-background: #fff;\n  --button-border-color: #000;\n  --button-color: #000;\n}\n\n.variant-accent {\n  --button-background: #FF9800;\n  --button-border-color: #FF9800;\n  --button-color: #000000;\n}\n\n.variant-ghost {\n  --button-background: #fff;\n  --button-border-color: #aaa;\n  --button-color: #555;\n}\n\n.variant-soft {\n  --button-background: #fff4df;\n  --button-border-color: #d9c6a5;\n  --button-color: #333;\n}\n\n.variant-danger {\n  --button-background: #C92A24;\n  --button-border-color: #C92A24;\n  --button-color: #fff;\n}\n\n.variant-danger-weak {\n  --button-background: #fff;\n  --button-border-color: #b3261e;\n  --button-color: #b3261e;\n}\n\n.size-small {\n  height: 32px;\n  padding-inline: 20px;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 700;\n}\n\n.size-medium {\n  height: 40px;\n  padding-inline: 24px;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 700;\n}\n\n.size-large {\n  height: 48px;\n  padding-inline: 24px;\n  font-size: 1rem; /* 16px */\n  font-weight: 700;\n}\n\n.shape-link.size-small,\n.shape-link.size-medium,\n.shape-link.size-large {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.root:disabled,\n.root[aria-disabled='true'] {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.is-block {\n  width: 100%;\n}\n\n.root .leading {\n  padding-right: 6px;\n}\n\n.root .trailing {\n  padding-left: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Button-module__root--xCMeY`,
	"shape-default": `Button-module__shape-default--XldmJ`,
	"shape-link": `Button-module__shape-link--GIp7Z`,
	"variant-default": `Button-module__variant-default--HtpMs`,
	"variant-primary": `Button-module__variant-primary--avKMr`,
	"variant-secondary": `Button-module__variant-secondary--i03KI`,
	"variant-accent": `Button-module__variant-accent--ECBUE`,
	"variant-ghost": `Button-module__variant-ghost--Yn10J`,
	"variant-soft": `Button-module__variant-soft--UhtQK`,
	"variant-danger": `Button-module__variant-danger--xk86T`,
	"variant-danger-weak": `Button-module__variant-danger-weak--vygj0`,
	"size-small": `Button-module__size-small--wyzgt`,
	"size-medium": `Button-module__size-medium--pkW8O`,
	"size-large": `Button-module__size-large--oV3hx`,
	"is-block": `Button-module__is-block--fanVi`,
	"leading": `Button-module__leading--zEd5L`,
	"trailing": `Button-module__trailing--YODmp`
};
export default ___CSS_LOADER_EXPORT___;
